module.exports = __webpack_public_path__ + "static/img/21.ba29d8b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imges/21.png
// module id = btNW
// module chunks = 1